import store from '@/store'
import { cloneDeep } from 'lodash'
import { getStorage, setStorage } from '@/utils/storage'
import { TICKET_RETENTION_POPUP_CD } from '@/utils/train-storage'
import { RightsTypeMap } from '@/common/constant'
import dayjs from 'dayjs'

const onlyOnlineRightArr = [RightsTypeMap.normal]
const maxAccPackageLevel = 50 // 加速包等级上限
const needUpdateRightArr = [RightsTypeMap.normal]

// 根据类型切换权益
function changeRightByType({ state, commit }, option) {
  const changeRightFun = store.mutations.train.setSelectRightInfo || {}
  const selectSeatInfo = store.state.train.selectSeatInfo || {}
  const targetType = option || 1
  // 权益全集 包含线下
  const rightInfoArr = selectSeatInfo.map(item => {
    const serviceInfo = item?.service_info || {}
    if (!serviceInfo?.serviceInfoList || !serviceInfo?.offlineService) return []
    return [serviceInfo.offlineService, ...serviceInfo.serviceInfoList]
  })
  const afterChangeRightInfoArr = rightInfoArr.map(arr => {
    const obj = arr.find(item =>
      item?.type === targetType
    )
    return obj
  }).filter(item => item)
  changeRightFun(cloneDeep(afterChangeRightInfoArr))
  checkAndFixLoginStatusForRight()
}

// 切换线下购票权益
function switchToOfflineRight() {
  const changeRightFun = store.mutations.train.setSelectRightInfo || {}
  const selectSeatInfo = store.state.train.selectSeatInfo || {}
  const offlineRightInfo = selectSeatInfo.map(item => {
    const serviceInfo = item?.service_info || {}
    if (!serviceInfo?.offlineService) return []
    return serviceInfo.offlineService
  }).filter(item => item)
  changeRightFun(cloneDeep(offlineRightInfo))
  checkAndFixLoginStatusForRight()
}

// 通过关系和时间校验并修改权利类型与票类型
function checkAndFixLoginStatusForRight() {
  const loginStatus = store.state.login12306.is12306Login
  const changeTicketTypeFun =
    store.mutations.makeOrder.setMakeOrderLoginType
  const curRightType =
    store.state.train.selectRightInfo?.[0]?.type || -1
  const isNight = store.state.train.trainInfo?.is_ticket_period || false
  if (curRightType === -1) return
  // 夜间直接切线下 不支持线下直接让后端弹窗进行后续操作 同时根据登录状态切购票类型
  if (onlyOnlineRightArr.includes(curRightType)) changeTicketTypeFun(0)
  else if (isNight || !loginStatus) changeTicketTypeFun(1)
  else changeTicketTypeFun(0)
}

// 普通购票挽留弹窗检验 6.11推退改无忧 后续若修改请修改这里的常量同时通知后端更新对应静态内容
function checkNormalTicketRetentionPopup({ commit }) {
  const preRetentionCdData = getStorage(TICKET_RETENTION_POPUP_CD)
  const loginStatus = store.state.login12306.is12306Login
  const preNormalCd = preRetentionCdData?.normal || {}
  const selectSeatInfo = store.state.train.selectSeatInfo || []
  const selectRightType = store.state.train.selectRightInfo?.[0]?.type
  const curTimeStamp = dayjs().unix()
  // 权益全集 不包含线下
  const rightInfoArr = selectSeatInfo.map(item => {
    const serviceInfo = item?.service_info || {}
    return serviceInfo?.serviceInfoList || {}
  })
  const worryfreeRightPopupInfo =
    rightInfoArr?.[0]?.find(item => item.type === RightsTypeMap.worryfree)?.pop_info || {}
  if (selectRightType === RightsTypeMap.worryfree || Object.keys(worryfreeRightPopupInfo).length === 0 || !needUpdateRightArr.includes(selectRightType) || !loginStatus) return false
  const retentionPopupLimitTimes = worryfreeRightPopupInfo?.pop_close_num || 0
  const retentionPopupProhibitTime = worryfreeRightPopupInfo?.prohibit_time || 0
  const prePopupTimes = preNormalCd?.times || 0
  const prePopupTimeStamp = preNormalCd?.timeStamp || 0
  const updatedNormalCd = {
    times: prePopupTimes,
    timeStamp: prePopupTimeStamp
  }
  let popupFlag = false
  if (prePopupTimes < retentionPopupLimitTimes && curTimeStamp - prePopupTimeStamp < retentionPopupProhibitTime) {
    updatedNormalCd.times = prePopupTimes + 1
    updatedNormalCd.timeStamp = prePopupTimeStamp
    popupFlag = true
    commit('openNormalRetentionDrawer')
  }
  else if (curTimeStamp - prePopupTimeStamp > retentionPopupProhibitTime) {
    updatedNormalCd.times = 1
    updatedNormalCd.timeStamp = curTimeStamp
    popupFlag = true
    commit('openNormalRetentionDrawer')
  }

  setStorage({
    key: TICKET_RETENTION_POPUP_CD,
    data: {
      ...preRetentionCdData,
      normal: updatedNormalCd
    }
  })
  return popupFlag
}

// 抢票挽留弹窗
function checkScrambleTicketRetentionPopup({ commit }, option) {
  const preRetentionCdData = getStorage(TICKET_RETENTION_POPUP_CD)
  const preGrabCd = preRetentionCdData?.scramble || {}
  const curTimeStamp = dayjs().unix()
  const scramblePopupInfo = store.state.train.packageInfo?.pop_info || {}
  const retentionPopupLimitTimes = scramblePopupInfo?.pop_close_num || 0
  const retentionPopupProhibitTime = scramblePopupInfo?.prohibit_time || 0
  const retentionPopupLowerLimitFee = scramblePopupInfo?.pop_open_price === 0 ? 0 : (scramblePopupInfo?.pop_open_price   || Number.MAX_SAFE_INTEGER)
  const prePopupTimes = preGrabCd?.times || 0
  const prePopupTimeStamp = preGrabCd?.timeStamp || 0
  const curAccPackageInfo = store.state.train.selectPackage || {}
  const scramblePrice = option || 0
  const updatedGrabCd = {
    times: prePopupTimes,
    timeStamp: prePopupTimeStamp
  }
  let popupFlag = false
  // 等级已经为上限 没有弹窗信息 价格小于弹窗下限, 不弹窗
  if (Object.keys(scramblePopupInfo).length === 0 || curAccPackageInfo?.status >= maxAccPackageLevel || scramblePrice < retentionPopupLowerLimitFee) {
    return false
  }
  // 时间与次数校验
  if (prePopupTimes < retentionPopupLimitTimes && curTimeStamp - prePopupTimeStamp < retentionPopupProhibitTime) {
    updatedGrabCd.times = prePopupTimes + 1
    updatedGrabCd.timeStamp = prePopupTimeStamp
    popupFlag = true
    commit('openScrambleRetentionDrawer')
  }
  else if (curTimeStamp - prePopupTimeStamp > retentionPopupProhibitTime) {
    updatedGrabCd.times = 1
    updatedGrabCd.timeStamp = curTimeStamp
    popupFlag = true
    commit('openScrambleRetentionDrawer')
  }
  setStorage({
    key: TICKET_RETENTION_POPUP_CD,
    data: {
      ...preRetentionCdData,
      scramble: updatedGrabCd
    }
  })
  return popupFlag
}
export default {
  changeRightByType,
  switchToOfflineRight,
  checkAndFixLoginStatusForRight,
  checkNormalTicketRetentionPopup,
  checkScrambleTicketRetentionPopup
}
